'use strict';

import 'angular';

import isEmptyFilter from './isEmpty';

const MODULE_NAME = 'brg.filters';

var app = angular.module(MODULE_NAME, []);
app.filter('isEmpty', isEmptyFilter);

export default MODULE_NAME;
